__turbopack_context__.v({
  "modalContent": "FolderRenameModal-module__tn_y_a__modalContent",
});
